import { supabase } from '../lib/supabaseClient';
import type { Branch } from '../types/db';

export async function fetchBranches() {
  const { data, error } = await supabase.from('branches').select('*');
  if (error) throw error;
  return data ?? [];
}

export async function createBranch(payload: { id: string; name: string; address: string }) {
  // PANGGIL EDGE FUNCTION (FINAL)
  const { data, error } = await supabase.functions.invoke('create-branch', {
    body: payload,
  });

  if (error) throw error;
  return data;
}

export async function updateBranch(id: string, payload: Partial<Branch>) {
  const { error } = await supabase.from('branches').update(payload).eq('id', id);
  if (error) throw error;
}

export async function deleteBranch(id: string) {
  const { error } = await supabase.from('branches').delete().eq('id', id);
  if (error) throw error;
}
